export const OORDEEL_KNOPPEN = [
  ["goed", "Goed", "bg-emerald-600 border-emerald-600 text-white"],
  ["niet", "Niet goed", "bg-rose-600 border-rose-600 text-white"],
  ["nvt", "N.v.t.", "bg-zinc-700 border-zinc-700 text-white"],
];
export const OORDEEL_LABEL = { goed: "Goed", niet: "Niet goed", nvt: "N.v.t." };
export const OORDEEL_TONE = { goed: "text-emerald-700 bg-emerald-50 border-emerald-200", niet: "text-rose-700 bg-rose-50 border-rose-200", nvt: "text-zinc-600 bg-zinc-50 border-zinc-200" };

export const fotoTekst = (n) => `${n} ${n === 1 ? "foto" : "foto's"}`;
export const beoordeeldTekst = (b) => (b ? `${b.aantal} van ${b.totaal} beoordeeld` : "");
export const nietGoedTekst = (n) => (n > 0 ? `${n} niet goed` : "");
export const isOmIdentiteit = (user) => user.role === "om" || (user.role === "oversight" && !!user.canDoOm);
// v17-R1 C1: oversight legt ook zonder OM-taken zelf een bezoek vast.
export const magBezoekVastleggen = (user) => user.role === "oversight" || isOmIdentiteit(user);

const naarBlob = (c) => new Promise((resolve, reject) => c.toBlob((b) => {
  c.width = 0; c.height = 0;   // canvasgeheugen direct vrijgeven
  b ? resolve(b) : reject(new Error("verkleinen mislukt"));
}, "image/jpeg", 0.8));

// R1 B8: createImageBitmap met EXIF-oriëntatie en verkleinen in één stap (minder geheugen); anders het <img>-pad.
async function viaBitmap(file, max) {
  const probe = await createImageBitmap(file, { imageOrientation: "from-image" });
  const s = Math.min(1, max / Math.max(probe.width, probe.height));
  const w = Math.max(1, Math.round(probe.width * s));
  const h = Math.max(1, Math.round(probe.height * s));
  probe.close();
  const bmp = await createImageBitmap(file, { resizeWidth: w, resizeHeight: h, resizeQuality: "high", imageOrientation: "from-image" });
  const c = document.createElement("canvas");
  c.width = w; c.height = h;
  c.getContext("2d").drawImage(bmp, 0, 0, w, h);
  bmp.close();
  return naarBlob(c);
}

function viaImg(file, max) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const s = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
      const c = document.createElement("canvas");
      c.width = Math.round(img.naturalWidth * s);
      c.height = Math.round(img.naturalHeight * s);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      naarBlob(c).then(resolve, reject);
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("Dit bestand kan niet als foto worden gelezen.")); };
    img.src = url;
  });
}

// Verklein in de browser tot max 1600px (lange kant), JPEG 0.8. Zet ook een iPhone-HEIC om naar JPEG.
export async function verklein(file, max = 1600) {
  if (typeof createImageBitmap === "function") {
    try { return await viaBitmap(file, max); } catch { /* bv. HEIC of oude Safari: val terug op <img> */ }
  }
  return viaImg(file, max);
}
